<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-box">
      <form @submit.prevent="submit">
        <!-- Nome -->
        <div class="campo">
          <label>*Nome:</label>
          <input v-model="form.nome" type="text" required="required" />
        </div>

        <!-- Descrição -->
        <div class="campo">
          <label>*Descrição:</label>
          <textarea v-model="form.descricao" rows="6"></textarea>
        </div>

        <div class="campo">
          <label>*Descrição EN:</label>
          <textarea v-model="form.descricao_en" rows="6"></textarea>
        </div>

        <!-- 3 inputs por linha -->
        <hr class="my-4" />
        <div class="linha-tripla">
          <div class="campo">
            <label>*E-mail:</label>
            <input v-model="form.email" type="text" />
          </div>

          <div class="campo">
            <label>*Telefone:</label>
            <input v-model="form.telefone" type="text" />
          </div>

          <div class="campo">
            <label>*Site:</label>
            <input
              v-model="form.site"
              type="text"
              placeholder="Ex: https://site.com.br"
            />
          </div>
        </div>

        <!-- 2 inputs por linha -->
        <hr class="my-4" />
        <div class="linha-dupla">
          <div class="campo">
            <label>*Lista</label>
            <select v-model="form.lista">
              <option value="" selected>Selecione...</option>
              <option
                v-for="lista in listaOpcoes"
                :key="lista.id"
                :value="lista.nome"
              >
                {{ lista.nome }}
              </option>
            </select>
          </div>

          <div class="campo">
            <label>*Local</label>
            <input v-model="form.local" type="text" />
          </div>
        </div>

        <!-- Redes sociais -->
        <hr class="my-4" />
        <div class="campo">
          <h3 class="mb-2">*Redes Sociais</h3>

          <div
            class="rede-item"
            v-for="(social, index) in form.redes"
            :key="social.id || index"
          >
            <div class="linha-dupla">
              <div class="campo">
                <label>Nome:</label>
                <select v-model="social.nome">
                  <option value="" selected>Selecione...</option>
                  <option
                    v-for="rede in nomeRedesSociais"
                    :key="rede.id"
                    :value="rede.nome"
                  >
                    {{ rede.nome }}
                  </option>
                </select>
              </div>

              <div class="campo">
                <label>Endereço (URL):</label>
                <input v-model="social.endereco" type="text" />
              </div>
            </div>

            <button class="btn-remover-img" @click.prevent="removerRede(index)">
              Remover Rede
            </button>
          </div>
          <button class="btn-save mt-2" @click.prevent="adicionarRede">
            + Adicionar Rede Social
          </button>
        </div>

        <!-- Status -->
        <hr class="my-4" />
        <div class="campo campo-status">
          <label>Ativar/Desativar:</label>

          <label class="switch">
            <input type="checkbox" v-model="form.status" />
            <span class="slider"></span>
          </label>
        </div>

        <!-- Imagens atuais -->
        <hr class="my-4" />
        <div class="campo">
          <h3 class="mb-2">Imagens atuais:</h3>

          <div class="lista-imagens">
            <div class="imagem-item" v-for="img in form.imagens" :key="img.id">
              <img
                class="thumb"
                :src="
                  parceiro.imagens.length
                    ? `${urlDasImg}${img.url}`
                    : require('@/assets/placeholder-image.jpg')
                "
                :alt="parceiro.nome"
              />

              <button
                class="btn-remover-img"
                @click.prevent="removerImagem(img)"
              >
                Remover
              </button>
            </div>
          </div>
        </div>

        <!-- Upload novas imagens -->
        <hr class="my-4" />
        <div class="campo">
          <h3 class="mb-2">Adicionar novas imagens:</h3>

          <div
            class="dropzone"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="dropFiles"
            @click="openFileDialog"
          >
            <p v-if="!isDragging">Clique ou arraste imagens aqui</p>
            <p v-else>Solte para enviar...</p>
            <p>Tamanho máximo 5 MB</p>

            <input
              ref="fileInput"
              type="file"
              multiple
              class="hidden-input"
              @change="handleFileUpload"
            />
          </div>
        </div>

        <!-- Preview -->
        <div v-if="form.novasImagens.length" class="lista-imagens mt-2">
          <div
            class="imagem-item"
            v-for="(file, index) in form.novasImagens"
            :key="index"
          >
            <img :src="file.preview" class="thumb" />
            <span class="text-xs text-gray-600">{{ file.name }}</span>
          </div>
        </div>

        <!-- Avisos -->
        <div class="form-hint">
          <div class="form-hint-main">
            <span class="asterisk">*</span>
            <span>Campos obrigatórios</span>
          </div>

          <div class="form-hint-note">
            <strong>Site:</strong>
            informe a URL completa, por exemplo
            <code>https://google.com</code>
          </div>
        </div>

        <!-- Botões -->
        <div class="botoes">
          <button type="submit" class="btn-save">Salvar</button>
          <button type="button" class="btn-cancel" @click="close">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { urlImg } from '@/services/services';
export default {
  name: 'EditParceiroModal',
  props: ['parceiro'],
  data() {
    return {
      urlDasImg: urlImg,
      isDragging: false,
      form: {
        ...this.parceiro,
        novasImagens: [],
        imagensRemovidas: [],
        redesRemovidas: [],
      },
      nomeRedesSociais: [
        {
          id: '1',
          nome: 'Instagram',
        },
        {
          id: '2',
          nome: 'Facebook',
        },
        {
          id: '3',
          nome: 'Youtube',
        },
        {
          id: '4',
          nome: 'Linkedin',
        },
      ],
      listaOpcoes: [
        {
          id: '1',
          nome: 'Terra do Vento',
        },
        {
          id: '2',
          nome: 'Outros / Brasil',
        },
        {
          id: '3',
          nome: 'América Latina',
        },
        {
          id: '4',
          nome: 'Mundo',
        },
      ],
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    removerImagem(img) {
      this.form.imagens = this.form.imagens.filter((i) => i.id !== img.id);
      this.form.imagensRemovidas.push(img.id);
    },

    removerRede(index) {
      const rede = this.form.redes[index];
      if (rede.id) this.form.redesRemovidas.push(rede.id);
      this.form.redes.splice(index, 1);
    },

    adicionarRede() {
      this.form.redes.push({
        id: null,
        nome: '',
        endereco: '',
      });
    },

    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      this.processFiles(files);
    },

    processFiles(files) {
      files.forEach((file) => {
        file.preview = URL.createObjectURL(file);
        this.form.novasImagens.push(file);
      });
    },

    openFileDialog() {
      this.$refs.fileInput.click();
    },

    dropFiles(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      this.processFiles(files);
    },

    submit() {
      this.$emit('salvar', this.form);
      this.close();
    },
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 20000;
}

.modal-box {
  background: white;
  padding: 20px;
  border-radius: 6px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
}

.linha-tripla {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.linha-dupla {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

@media (max-width: 700px) {
  .linha-tripla,
  .linha-dupla {
    grid-template-columns: 1fr;
  }
}

.campo {
  margin-bottom: 15px;
}

input,
textarea,
select {
  padding: 10px 12px;
  width: 100%;
  box-sizing: border-box;
}

input,
select,
textarea {
  width: 100%;
  padding: 10px 20px;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
}

.lista-imagens {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.imagem-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
}

.btn-remover-img {
  background: #c33;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 0.75rem;
}

.btn-save {
  background: #008b23;
  color: white;
  padding: 8px 14px;
  border-radius: 4px;
}

.btn-cancel {
  background: #c33;
  color: white;
  padding: 8px 14px;
  border-radius: 4px;
  margin-left: 10px;
}

.botoes {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.campo-status {
  display: flex;
  align-items: center;
  gap: 15px;
}

.switch {
  position: relative;
  width: 46px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  inset: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.3s;
}

.slider:before {
  content: '';
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s;
}

input:checked + .slider {
  background: #4a4a4a;
}

input:checked + .slider:before {
  transform: translateX(22px);
}

.dropzone {
  border: 2px dashed #999;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s;
  color: #555;
}

.dropzone:hover {
  border-color: #666;
  background: #f8f8f8;
}

.dropzone.drag-active,
.dropzone:active {
  border-color: #008b23;
  background: #e8ffe8;
}

.hidden-input {
  display: none;
}

.form-hint {
  font-size: 0.85rem;
  color: #6c757d;
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-hint-main {
  display: flex;
  align-items: center;
  gap: 4px;
}

.form-hint .asterisk {
  color: #dc3545;
  font-weight: bold;
}

.form-hint-note {
  font-size: 0.8rem;
  color: #555;
  padding-left: 14px;
  border-left: 2px solid #e0e0e0;
}

.form-hint-note code {
  background: #f1f1f1;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.78rem;
}

@media (max-width: 640px) {
  /* modal ocupa quase toda a tela */
  .modal-overlay {
    padding: 10px;
  }

  .modal-box {
    max-width: 100%;
    max-height: 95vh;
    padding: 16px;
    border-radius: 4px;
  }

  /* grids viram coluna */
  .linha-tripla,
  .linha-dupla {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  /* textos mais compactos */
  label {
    font-size: 0.85rem;
  }

  input,
  textarea,
  select {
    font-size: 0.9rem;
  }

  /* botões empilhados */
  .botoes {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-save,
  .btn-cancel {
    width: 100%;
  }

  .btn-cancel {
    margin-left: 0;
  }

  /* previews menores */
  .thumb {
    width: 64px;
    height: 64px;
  }

  /* dropzone mais compacta */
  .dropzone {
    padding: 20px;
    font-size: 0.85rem;
  }
}
@media (min-width: 641px) and (max-width: 1023px) {
  .modal-box {
    max-width: 90%;
  }

  /* tripla vira dupla no tablet */
  .linha-tripla {
    grid-template-columns: repeat(2, 1fr);
  }

  .linha-dupla {
    grid-template-columns: repeat(2, 1fr);
  }

  /* botões lado a lado */
  .botoes {
    justify-content: flex-end;
  }

  /* thumbnails intermediárias */
  .thumb {
    width: 72px;
    height: 72px;
  }

  .dropzone {
    padding: 24px;
  }
}
</style>
